import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { ToastContainer, toast } from 'react-toastify';
import { motion } from 'framer-motion';
import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';
import backgroundImage from '../loginbackgroundimage.webp';
import backgroundImageMain from '../background.webp';
import loginImage from '../loginimage.webp';
import buttonImage from '../buttonimage.webp';
import cardBackgroundImage from '../cardbackground.webp';
import { Helmet } from 'react-helmet';

const Login = ({ setCurrentPage }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        if (!email || !password) {
            toast.error('Please fill in all fields.');
            return;
        }

        setLoading(true);
        try {
            const { error } = await supabase.auth.signInWithPassword({
                email,
                password,
            });

            if (error) {
                toast.error('Invalid credentials.');
                return;
            }

            setCurrentPage('home');
        } catch (err) {
            toast.error('An unexpected error occurred.');
            console.error('Login error:', err.message);
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    return (
        <>
            <Helmet>
                <title>Companion Julie App </title>
                <meta property="og:title" content="Companion Julie App " />
                <meta name="msvalidate.01" content="969227A774884D60C4474B07A23319AB" />
            </Helmet>


            <MainWrapper>
                <LeftImageWrapper>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <MarketingImage
                            src={process.env.PUBLIC_URL + '/images/companionappmarketing2.webp'}
                            alt="Companion App Marketing"
                        />
                        <div style={{ height: '10px' }} />
                        <LeftInfoCard>
                            Your Self Reflection Companion. We all get stuck sometimes. This space offers tools for clarity, and steady encouragement to help you keep moving forward. Monthly and Yearly Subscriptions Available for full Access. Discover self-reflection tools for personal growth. Including Journal, Chat, Oracle, Interactive Guided Reflection, Meditation, Questions and Answers by Julie for Reflection only. Sessions are guided through the app. Periodic Live Streams and regularly updated Q&amp;A Section keeps things fresh. The App offers tools, answers to reflect on, and insight when you need them most. All Members will have access to Mobile and Browser versions of the App. $5.55 per month or $55 per year.
                        </LeftInfoCard>
                    </div>
                </LeftImageWrapper>
                <RightColumn>
                    <Card
                        as={motion.div}
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <Title>LOGIN</Title>
                        <Content>
                            <Form>
                                <Input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <PasswordContainer>
                                    <Input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <ToggleIcon onClick={togglePasswordVisibility}>
                                        {showPassword ? '🙈' : '👁️'}
                                    </ToggleIcon>
                                </PasswordContainer>
                                <Button onClick={handleLogin} disabled={loading}>
                                    {loading ? <ClipLoader size={20} color="#FFFFFF" /> : 'Login'}
                                </Button>
                                <Button onClick={() => setCurrentPage('signup')}>
                                    Sign Up
                                </Button>
                            </Form>
                            <Image src={loginImage} alt="Login" />
                        </Content>
                    </Card>
                    <DownloadCard>
                        <DownloadTitle>
No Download Required!<br /> Now Live <br /> -Contact for Gift Subscription in exchange for Honest Review- Limited Number Available <br /> - Download the App on Play Store Soon <br /> Please Report any discovered issues on the My Account page as this is a new app. Thank you!  </DownloadTitle>
                        {/* Download button or instructions can be added here */}
                    </DownloadCard>
                </RightColumn>
                <ToastContainer />
            </MainWrapper>
            <GridBackground>
                <GridWrapper>
                    { [
                        { img: 'cj1.webp', title: 'Choose your nickname', desc: 'You have the option to customize your greeting name or keep it defaulted to your first name. Paid members get unlimited new sessions, the ability to save your session and pick back up where you left off later, as well as access to the Chat room and JulieCam Live Streams with Full Access to the App' },
                        { img: 'cj2.webp', title: 'Get your inner thoughts out', desc: 'Keep a Running Journal or Write letters you never send. It can be so helpful to have a safe place to express your thoughts and feelings. Entries are encrypted on the backend, so that no one but you can read your journal.' },
                        { img: 'cj3.webp', title: 'Add the content you want to see', desc: 'Have a question you want to schedule in? Your Question and Answer will be added to the database. Access the library of answered topics to help expand on your own perspectives by considering what has been shared. All offered answers are produced through Oracle, Tarot, or opinions and experiential recounts given with the agreement that you will use it as information to reflect on in order to decide what is true for you. Answers are offered via the library and are available to all members.' },
                        { img: 'cj4.webp', title: 'New session guidance', desc: 'Step by Step guided process of reflecting on and deciding what method is best for you in your current situation. Recognize old patterns or experiences you are ready to revisit for self-reflection.' },
                        { img: 'jcompanion2.webp', title: 'J is your session helper', desc: 'Easy navigation around the site while in session. Save and pick up where you left off.' },
                        { img: 'cj6.webp', title: 'Take notes', desc: 'One example is the strengths worksheet, which encourages you to take an inventory, while the description offers a way to utilize that information to optimize your reflecting. Use the Oracle to help gain insights into your strengths by reflecting on what is offered in your reading. Save everything to access again later.' },
                        { img: 'cj7.webp', title: 'Expand your perspective', desc: 'Over 44 Components featuring concepts that lend to Self-Reflection. The App contains references to personal spiritual wisdoms gained for you to reflect on; and spiritual concepts as well as references to other teachers to investigate further.' },
                        { img: 'companionjuliemarket2.webp', title: 'Use the formula', desc: 'Reflecting Formulas guides through the process that assists you to reflect on looping, unwanted, or limiting habits or patterns.  The formula is set up to be your reflection companion through sometimes difficult topics of your own choosing.' },
                        { img: 'cj5.webp', title: 'Keep track of what is next', desc: 'When you come to something you need to process but don\'t have time, or if you uncover something you want to self inquire deeper into later, use the to-do list to keep track and mark your progress.  If you need to finish your session and want to keep track of where you were at, add it to the list.  You can also use the list for practical items you want the satisfaction of checking off as you complete.' }
                    ].map((item, idx) => (
                        <GridCard key={idx}>
                            <GridCardTitle>{item.title}</GridCardTitle>
                            <GridCardImage src={process.env.PUBLIC_URL + '/images/' + item.img} alt={item.title} />
                            <GridCardDesc>{item.desc}</GridCardDesc>
                        </GridCard>
                    ))}
                </GridWrapper>
            </GridBackground>
            <FooterCard>
                Contact Us: Startellina@gmail.com<br/>
                CompanionJulie app is Copywright protected
            </FooterCard>
        </>
    );
};

export default Login;

// Styled Components
const MainWrapper = styled.div`
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px;
    @media (max-width: 900px) {
        flex-direction: column;
        padding: 10px;
    }
`;

const LeftImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 40px;
    @media (max-width: 900px) {
        margin-right: 0;
        margin-bottom: 20px;
    }
`;

const MarketingImage = styled.img`
    height: 400px;
    width: auto;
    max-width: 100vw;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
    object-fit: cover;
    margin-top: 0px;
    @media (max-width: 600px) {
        width: 98vw;
        height: auto;
        max-width: 98vw;
        margin-top: 0;
    }
`;

const RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: -9px; /* Was -25px, now 10px lower */
    @media (max-width: 900px) {
        width: 100%;
        gap: 8px;
        margin-top: 0px;
    }
`;

const Card = styled.div`
    width: 400px;
    background-image: url(${cardBackgroundImage});
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 12px 20px 20px 20px; /* Reduce top padding from 20px to 12px */

    @media (max-width: 600px) {
        width: 90%;
    }
`;

const Title = styled.h2`
    font-family: 'Times New Roman', Times, serif;
    font-size: 24px;
    font-weight: bold;
    color: #4b5563;
    margin-bottom: 20px;

    @media (max-width: 600px) {
        font-size: 20px;
    }
`;

const Content = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    @media (max-width: 600px) {
        flex-direction: column;
    }
`;

const Image = styled.img`
    width: 133px;
    border-radius: 5px;
    margin-left: 10px;

    @media (max-width: 600px) {
        margin-left: 0;
        margin-top: 10px;
    }
`;

const Form = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-right: 20px;
`;

const Input = styled.input`
    width: 100%;
    padding: 10px;
    border: 2px solid black;
    border-radius: 5px;
    font-family: Arial, sans-serif;
    font-size: 14px;
    box-sizing: border-box; /* Ensure padding doesn't affect width */
    margin: 0; /* Remove any default margin */

    @media (max-width: 600px) {
        font-size: 12px;
    }
`;

const PasswordContainer = styled.div`
    position: relative;
    width: 100%;
    margin: 0; /* Ensure no extra margin */
    padding: 0; /* Ensure no extra padding */
`;

const ToggleIcon = styled.span`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 16px;
    color: #4b5563;

    @media (max-width: 600px) {
        font-size: 14px;
        right: 8px;
    }
`;

const Button = styled.button`
    width: 100%;
    padding: 10px;
    background-image: url(${buttonImage});
    background-size: cover;
    border: 2px solid black;
    border-radius: 5px;
    font-family: 'Times New Roman', Times, serif;
    font-size: 16px;
    font-weight: bold;
    color: white;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    @media (max-width: 600px) {
        font-size: 14px;
    }
`;

const DownloadCard = styled.div`
    width: 400px;
    background-image: url(${cardBackgroundImage});
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 12px 20px 20px 20px; /* Reduce top padding from 20px to 12px */
    margin-top: -4px;
    @media (max-width: 600px) {
        width: 90%;
    }
`;

const DownloadTitle = styled.h3`
    font-family: 'Times New Roman', Times, serif;
    font-size: 20px;
    font-weight: bold;
    color: #4b5563;
    margin-bottom: 10px;
`;

const GridBackground = styled.div`
    width: 100vw;
    background-image: url(${backgroundImageMain});
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0;
`;

const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-top: 32px;
    margin-bottom: 32px;
    width: 100vw;
    max-width: 1240px;
    padding: 0 24px;
    box-sizing: border-box;
    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        gap: 16px;
        padding: 0 4vw;
    }
`;

const GridCard = styled.div`
    background-image: url(${cardBackgroundImage});
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 20px 10px 16px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 260px;
    @media (max-width: 600px) {
        min-height: 220px;
        padding: 10px 4px 10px 4px;
    }
`;

const GridCardTitle = styled.h4`
    font-family: 'Times New Roman', Times, serif;
    font-size: 18px;
    font-weight: bold;
    color: #4b5563;
    margin-bottom: 10px;
`;

const GridCardImage = styled.img`
    width: 100%;
    max-width: 320px;
    height: 220px;
    object-fit: contain;
    border-radius: 8px;
    margin-bottom: 10px;
    background: #fff;
    @media (max-width: 600px) {
        height: 180px;
        max-width: 98vw;
        margin-bottom: 8px;
    }
`;

const GridCardDesc = styled.p`
    font-family: 'Times New Roman', Times, serif;
    font-size: 15px;
    color: #4b5563;
    margin: 0;
`;

const FooterCard = styled.div`
    width: 100vw;
    background-image: url(${cardBackgroundImage});
    background-size: cover;
    background-position: center;
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    border-radius: 0;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    text-align: center;
    padding: 24px 0 24px 0;
    font-family: 'Times New Roman', Times, serif;
    font-size: 12px; /* Reduce font size */
    font-weight: normal; /* Remove bold */
    color: #4b5563;
    margin: 0;
`;

const LeftInfoCard = styled.div`
    width: 715px;
    background-image: url(${cardBackgroundImage});
    background-size: cover;
    background-position: center;
    border: 2px solid black;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 8px 12px;
    margin-top: -4px;
    font-family: 'Times New Roman', Times, serif;
    font-size: 14px;
    font-weight: bold;
    color: #4b5563;
    @media (max-width: 900px) {
        width: 98vw;
        font-size: 14px;
        padding: 6px 6px;
    }
`;